import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import WpButton from 'Wpds/components/button/WpButton';

import { advanceOnboardingStateAction } from 'Shared/actions/onboardingState';
import ConnectCalendarButtons from './ConnectCalendarButtons/ConnectCalendarButtons';
import ConnectCalendarContentArea from './ConnectCalendarContentArea/ConnectCalendarContentArea';
import SignUpTermsAgreement from 'Shared/components/SignUpTermsAgreement/SignUpTermsAgreement';

import { userAgentIsInApp } from 'Shared/helpers';

import './ConnectCalendar.scss';

type Props = {
  userCreatedInMiddle: boolean;
  cannotSignIntoGoogle: boolean;
  OAuthOnlyWithCalendar?: boolean;
};

function ConnectCalendar({ userCreatedInMiddle, cannotSignIntoGoogle, OAuthOnlyWithCalendar = false }: Props) {
  const dispatch = useDispatch();
  const handleSkipClick = useCallback(() => dispatch(advanceOnboardingStateAction({ didSkip: true })), [dispatch]);
  const canOpenWindow = !cannotSignIntoGoogle && !userAgentIsInApp(navigator.userAgent);
  return (
    <div className="profile d-flex">
      <ConnectCalendarContentArea />

      <div className="profile-form-container-connect-calendar d-flex flex-column justify-content-center align-items-center w-100">
        <div className="create-account-form-area pb-lg-4 py-lg-5 mt-lg-5 mx-auto d-flex flex-column h-100">
          <div className="d-flex flex-column h-100">
            {!userCreatedInMiddle && (
              <>
                <div className="create-account-form-area-title mt-lg-5">Connect your Calendar</div>
                <div className="create-account-form-area-description mt-3 pb-2">
                  Connect your work calendar so Perform can create workspaces for your meetings
                </div>
              </>
            )}
            <div className="profile-form-content d-flex flex-column w-100">
              {userCreatedInMiddle ? (
                <>
                  <div className="create-account-form-area-title mt-lg-5">You already connected your Calendar</div>
                  <p />
                  <WpButton variant="primary" size="lg" onClick={handleSkipClick}>
                    Return
                  </WpButton>
                </>
              ) : (
                <>
                  <ConnectCalendarButtons openWindow={canOpenWindow} cannotSignIntoGoogle={cannotSignIntoGoogle} />
                  <p />
                  {!OAuthOnlyWithCalendar && (
                    <WpButton
                      size="lg"
                      variant={cannotSignIntoGoogle ? 'secondary' : 'tertiary'}
                      onClick={handleSkipClick}
                    >
                      Not now
                    </WpButton>
                  )}
                </>
              )}
            </div>
          </div>
          {!userCreatedInMiddle && (
            <SignUpTermsAgreement
              prefixText="By connecting calendar"
              className="MobileConnectCalendar__terms text-center px-1 mt-4 pb-3"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default ConnectCalendar;
